

const BIND_EXCLUDED_METHODS = {
  constructor: true,
  render: true
}

class Core extends HTMLElement {
  static autobind = true;

  constructor() {
    super();
    this.sectionId = this.getAttribute('section-id');
    if (typeof this.onIntersect == 'function') {
      this.observer = new IntersectionObserver((entries) => {
        this.onIntersect(entries[0].isIntersecting);
      })
      this.observer.observe(this);
    }
    this._subs = {};

    // experimental
    // this._autobind();
  }
  // _autobind() {
  //   for(name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
  //     if (typeof this[name] === 'function' && BIND_EXCLUDED_METHODS[name] !== true) {
  //       this[name] = this[name].bind(this);
  //     }
  //   }
  // }

  subscribe(eventName, options) {
    const handler = this.subscriptions[eventName];
    const handleFn = e => {
      if(options?.global || this.sectionId && this.sectionId === e.detail.sectionId) {
          const handler = this.subscriptions[eventName];
          this[handler](e.detail.data, e.detail.sectionId, e);
        }
    };

    this._subs[handler] = handleFn.bind(this);

    document.addEventListener(eventName, this._subs[handler], {
      once: !!options?.once,
      capture: true
    })

    // console.log(this._subs);

    // document.addEventListener(eventName, (e) => {
    //   if(options?.global || this.sectionId === e.detail.sectionId) {
    //     const handler = this.subscriptions[eventName];
    //     this[handler](e.detail.data, e.detail.sectionId, e);
    //   }
    // }, {
    //   once: !!options?.once,
    //   capture: true
    // });

    // const handler = this.subscriptions[eventName];

    // document.addEventListener(eventName, this[handler], {
    //   once: !!options?.once,
    //   capture: true
    // })
  }

  async publish(eventName, data) {
    const { publishEvent } = await importModule('Utils');
    publishEvent(eventName, data, this.sectionId)
    // const event = new CustomEvent(eventName, {
    // 	bubbles: false,
    //   cancelable: true,
    //   composed: true,
    // detail: {
    //   	sectionId: this.sectionId,
    //     data
    //   }
    // })
    // document.dispatchEvent(event);
  }

  getParentSection() {
    return document.getElementById(`shopify-section-${this.sectionId}`)
  }

  connectedCallback() {
    

    
    // if(this.subscriptions) {
    //   for (const [key, value] of Object.entries(this.subscriptions)) {
    //     if(typeof this[value] == 'function') {
    //       this[value] = this[value].bind(this);
    //     }
    //   } 
    // }
    if (this.elements) {
      for (const [key, value] of Object.entries(this.elements)) {
        this[`$${key}`] = value[0] === "*" 
          ? Array.from(this.querySelectorAll(value.substring(1)))
          : this.querySelector(value);
      }
    }

    if (typeof this.render == 'function') {
      this.render();
    }
  }

  disconnectedCallback() {
    if(typeof this.disconnect == 'function') {
      this.disconnect();
    }
    if (this.subscriptions) {
      for (const [key, value] of Object.entries(this.subscriptions)) {
        if(typeof this._subs[value] == 'function') {
          document.removeEventListener(key, this._subs[value], true); 
        }
      }
    }
   }

  reRender(doc, selector, root) {
    if(!selector) {
      selector = `${this.tagName}[section-id="${this.sectionId}"]`;
    }
    if(!root) {
      root = this;
    }
    const target = doc.querySelector(selector);
    root.replaceChildren(...target.cloneNode(true).childNodes);
  }

  $get(el, src = this) {
    return src.querySelector(this.elements[el]);
  }
}

export { Core, Core as default };




 
var decreaseButton = document.querySelector('.qty-decreaseButton'),
    increaseButton = document.querySelector('.qty-increaseButton'),
    quantityInput = document.querySelector('[data-input]');

decreaseButton?.addEventListener('click', decreaseQuantity);
increaseButton?.addEventListener('click', increaseQuantity);

function decreaseQuantity() {
  let quantity = parseInt(quantityInput.value);

  if (quantity > 1) {
    quantity--;
    quantityInput.value = quantity;
  }
}

function increaseQuantity() {
  let checkMaxAttr = quantityInput.getAttribute("max");
  let Maxquantity = parseInt(quantityInput.getAttribute("max"));
  let quantity = parseInt(quantityInput.value);
  if(checkMaxAttr != null){
    if(Maxquantity > quantity){
      quantity++;
      quantityInput.value = quantity;
    }
  }else {
    quantity++;
    quantityInput.value = quantity;
  }
}


// icon feature fix height js - DM - J

function setEHeight() {
  const maxHeight = () => {
    let heightarr = [];
    const elements = document.querySelectorAll(".features__icon");
    elements.forEach(function (element) {
      heightarr.push(element.offsetHeight);
    });
    return Math.max(...heightarr);
  };
  const getMaxHeight = maxHeight();
  const icons = document.querySelectorAll(".features__icon");
  icons.forEach(function (icon) {
    icon.style.height = getMaxHeight + "px";
  });
}

setEHeight();

// Reward popup js

// 1ts
setTimeout(function () {
  
  function rewardsSubHeading(name) {
      let myDiv = document.createElement('div');
      myDiv.textContent = name;
      myDiv.classList.add("join_now");
      return myDiv;
  }
  const subText = document.querySelector('.yotpo-drawer-logged-out-headline-text');
  if (subText != null) {
    subText.prepend(rewardsSubHeading('Join Now'));
  }
  
  // 2nd
  function rewardSvg(name) {
      let mysvg = document.createElement('div');
      mysvg.innerHTML = name;
      mysvg.classList.add("join_now_svg");
      return mysvg;
  }
  const SvgIcon = document.querySelector('.yotpo-drawer-sign-up-item');
  if (SvgIcon != null) {
    SvgIcon.prepend(rewardSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="55.683" height="50.703" viewBox="0 0 55.683 50.703">
    <path id="Path_1168" data-name="Path 1168" d="M34.506,56.12a11.225,11.225,0,0,1-1.675-.125,15.963,15.963,0,0,1-8.78-4.986A16.768,16.768,0,0,1,11.92,46.323C3.315,38.52-1.605,25.742.475,16.613A13.463,13.463,0,0,1,10.064,6.274,15.493,15.493,0,0,1,22.778,7.431,18.455,18.455,0,0,1,29.1,14.017a12.1,12.1,0,0,1,3.736-4.728c2.807-2.045,6.338-2.463,10.5-1.241C49.243,9.783,53.662,15.075,55.152,22.2c1.749,8.356-.484,20.729-11.995,30.392A13.418,13.418,0,0,1,34.5,56.121m-4.393-6.413a8.548,8.548,0,0,0,3.445,1.429c2.11.316,4.217-.437,6.443-2.306,9.853-8.269,11.8-18.658,10.353-25.625-1.114-5.325-4.248-9.23-8.395-10.446-2.651-.778-4.68-.617-6.211.491-2.782,2.017-3.532,6.946-3.585,8.675a2.456,2.456,0,0,1-4.853.46c-.016-.071-1.78-7.655-7.034-10.734a10.656,10.656,0,0,0-8.8-.67A8.523,8.523,0,0,0,5.27,17.7c-1.667,7.29,2.8,18.5,9.949,24.981a13.329,13.329,0,0,0,4.437,2.749c-.221-.335-.421-.643-.6-.92-.212-.329-.384-.595-.514-.777-2.827-4-3.851-8.53-2.735-12.139a7.4,7.4,0,0,1,4.483-4.94,7.13,7.13,0,0,1,5.941.25,8.352,8.352,0,0,1,2.749,2.415,8.622,8.622,0,0,1,5.045-2.329,7.566,7.566,0,0,1,7.648,4.792c2.064,4.45-.75,10.849-6.679,15.214a21.629,21.629,0,0,1-4.883,2.71M23.076,31.035a3.091,3.091,0,0,0-1.077.22,2.625,2.625,0,0,0-1.5,1.785c-.515,1.668-.25,4.605,2.052,7.85.157.222.375.547.625.947a43.625,43.625,0,0,0,2.839,3.979,16.35,16.35,0,0,0,6.066-2.771c4.191-3.084,6.037-7.247,5.134-9.191-.656-1.416-1.569-2.08-2.733-1.968a4.181,4.181,0,0,0-3.373,3.066,2.456,2.456,0,0,1-4.76.01c-.194-.74-1.053-3.011-2.413-3.718a1.777,1.777,0,0,0-.86-.209" transform="translate(0 -5.418)" fill="#fff"/>
    </svg>`));
  }
},5000)



setTimeout(function() {
  var exploreBtn = document.querySelector("main-navigation .item-babyshop-rewards.has_open_popup a");
  var btnopenpopuup = document.querySelector(".yotpo-banner-layout");
  var btnclosedrawer = document.querySelector("modal-close[data-close]");
      
  exploreBtn?.addEventListener("click",function(e) {
    e.preventDefault();
      btnclosedrawer?.click();
      setTimeout(function() {
        btnopenpopuup?.click();
      },200)
  })
},1000);





